import { FieldErrors, get, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

export interface FormErrorMessageProps {
  errors?: FieldErrors
  name: string
  'data-testid': string
}

export default function FormErrorMessage({
  errors,
  name,
  'data-testid': testId
}: Readonly<FormErrorMessageProps>) {
  const { t } = useTranslation('common')

  const methods = useFormContext()
  const formErrors = methods?.formState?.errors
  const error = get(errors ?? formErrors, name)

  if (!error) {
    return null
  }

  return (
    <span className="text-red-500 dark:text-red-400" data-testid={testId}>
      {t(error.message)}
    </span>
  )
}
